import { COLORS_VALUES as colors } from './colors';
import breakpoints from './breakpoints';
import space from './space';
import {
  FONT_SIZES as fontSizes,
  LINE_HEIGHTS as lineHeights,
  FONT_WEIGHTS as fontWeights,
} from './fonts';

const theme = {
  breakpoints,
  colors,
  fontSizes,
  lineHeights,
  fontWeights,
  space,
};

export default theme;
